import React from 'react';
import { Typography } from '@mui/material';

const Limit100Alert = ({ isFromPartner, partnerEmail, meterNames = [] }) => {
  const meterLabel = meterNames.length ? meterNames.join(', ') : 'one or more meters';

  return (
    <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px' }}>
      <Typography
        variant="body1"
        sx={{
          fontSize: '1rem',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        {isFromPartner
          ? `You have reached 100% of your invoice usage limit for ${meterLabel} in the current subscription period. Please reach out to ${partnerEmail}.`
          : `You have reached 100% of your invoice usage limit for ${meterLabel} in the current subscription period. Upgrade or renew to continue.`}
      </Typography>
    </div>
  );
};

export default Limit100Alert;
